import {
  SelectOption,
  selectOptionActions,
} from "@/business/shared/commons/selectOption";
import { IdType } from "../domain/idType";

export const getIdTypesLikeSelectOption = {
  async execute(idTypes: IdType[]): Promise<SelectOption[]> {
    return idTypes.map((idType) =>
      selectOptionActions().create(idType.idType, idType.type)
    );
  },
};
